export const LOCK_SCREEN_CLASS = 'u-lock-screen';
